import loadable from "utils/loadable";

export const HalamanSettings = loadable(() => import("./index"));
export const LinkReferal = loadable(() => import("./LinkReferal"));
export const ListHasilReferral = loadable(() => import("./ListHasilReferral"));
export const UbahPassword = loadable(() => import("./UbahPassword"));
export const Profile = loadable(() => import("./Profile"));
